import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';

import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { INavigation, Navigation } from '@models/navigation';
import { IPermissionCheck } from '@models/role';
import { IUserDTO } from '@models/user';
import { RouteService } from '@core/services/route.service';
import { UserStateService } from '@core/services/state/user-state.service';
import { SelectedClassroomStateService } from '@app/infrastructure/core/services/state/selected-classroom-state.service';

@Component({
  selector: 'app-top-navigation',
  template: `
    <app-top-navigation-presentation
      [isValid]="isValid$ | async"
      [loggedInUser]="loggedInUser$ | async"
      [navLinks]="navLinks"
      [profileLinks]="profileLinks"
      [route]="url"
    ></app-top-navigation-presentation>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavigationSmartComponent implements OnInit {
  public isValid$: Observable<boolean>;
  public loggedInUser$: Observable<IUserDTO>;
  public navLinks: INavigation[];
  public permissionCheck: IPermissionCheck;
  public profileLinks: INavigation[];
  public url: string = '';

  private subscriptions: Subscription[] = [];

  constructor(
    private cd: ChangeDetectorRef,
    private routeService: RouteService,
    private userStateService: UserStateService,
    private selectedClassroomService: SelectedClassroomStateService,
  ) {}

  public ngOnInit(): void {
    this.isValid$ = this.isValid();
    this.loggedInUser$ = this.getLoggedInUser();
    this.buildNavLinkListBasedOnRole();
    this.getRoute();
    this.setupClassroomUpdate();
  }

  public buildNavLinkListBasedOnRole(): void {
    this.userStateService
      .checkUserPermissions()
      .subscribe((permissionCheck) => {
        this.permissionCheck = permissionCheck;
        this.navLinks = Navigation.buildNavLinkList(permissionCheck);
      });
  }

  public getLoggedInUser(): Observable<IUserDTO> {
    return this.userStateService.getUserSession();
  }

  public isValid(): Observable<boolean> {
    return this.userStateService
      .checkUserPermissions()
      .pipe(map((checkPermission) => checkPermission.isValid));
  }

  private getRoute(): void {
    const routeSubscription = this.routeService
      .getRoute()
      .subscribe((route) => {
        this.url = route;
        this.cd.markForCheck();
      });
    this.subscriptions.push(routeSubscription);
  }

  // TODO: Figure out a different option for this
  private setupClassroomUpdate(): void {
    this.selectedClassroomService.selectedClassroom$.subscribe(
      (classroomId) => {
        this.buildNavLinkListBasedOnRole();
      },
    );
  }
}
